import { lazyLoad } from "utils/loadable";

export const EmployerDashBoard = lazyLoad(
  () => import("./index"),
  (module) => module.EmployerDashBoard
);
